// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__tbBCm","expandIcon":"AccordionButton_expandIcon__ihHkr","expanded":"AccordionButton_expanded__1WsLY"};